<div class="user-section py-2">
    <h3 class="us_title">profile</h3>
    <div class="row justify-content-center">
        <div class="col-md-12">
            <div class="profile_data" *ngIf="data">
                <h4>{{data?.username}}</h4>
                <p>Total Balance: <small class="credit">{{data?.balance}}</small></p>
                <p>Exposer: <small class="debit">{{data?.expose}}</small></p>
                <p>Credit: <small class="credit">{{data?.available_balance}}</small></p>
            </div>
            <div class="profile_data" *ngIf="!data">
              <app-loader class="no-overlay"></app-loader>
            </div>
        </div>    
    </div>
</div>

